export enum SuggestionMenuEnum {
  SUGGESTIONS = "SUGGESTIONS",
  FAVORITES = "FAVORITES",
}
